import { render, staticRenderFns } from "./MonitorMapDetail.vue?vue&type=template&id=2247490a"
import script from "./MonitorMapDetail.vue?vue&type=script&lang=js"
export * from "./MonitorMapDetail.vue?vue&type=script&lang=js"
import style0 from "./MonitorMapDetail.vue?vue&type=style&index=0&id=2247490a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports